import { ROLE_REPORTING_ADMIN } from '~/consts/roles';

/** Use the existing authenticated Reporting Admin role, in every environment. */
export function isLtlpManifestEnabled(user: { roles?: Array<string> } | null | undefined): boolean {
  return Boolean(user?.roles?.includes(ROLE_REPORTING_ADMIN));
}
